import { useCallback, useContext } from 'react'
import { ContextShell } from '../../modules/context'
import { ExperimentProps, UseExperimentHook, UserContext } from '../../types'

export const useExperiment = (): UseExperimentHook => {
  const { MoisesCLI, retry } = useContext(ContextShell)

  const assignExperiment = useCallback(
    async ({ flag, personProperties = {} }: ExperimentProps) => {
      const experiment = await MoisesCLI.assignExperiment({
        flag,
        personProperties
      })

      return experiment?.value
    },
    [MoisesCLI]
  )

  const getExperimentVariant = useCallback(
    async ({ flag, personProperties, forceAssign = true }: ExperimentProps) => {
      const refreshedUser = await retry()

      // @ts-ignore
      const user = refreshedUser?.user as UserContext

      const result = user?.experiments?.find(
        (experiment) => experiment.flag === flag
      )

      if (result) {
        return result?.variant?.value
      }

      if (!forceAssign) return 'control'

      const assignedVariant = await assignExperiment({
        flag,
        personProperties
      })

      return assignedVariant
    },
    [assignExperiment, retry]
  )

  return { assignExperiment, getExperimentVariant }
}
